<template>
  <div class="medicalBox">
    <img src="https://cdn.youjiajk.com/%E5%AE%98%E7%BD%91-banner5.png" width="100%" />
    <!-- 一站式管理服务 -->
    <div class="container healthServe">
      <div class="title">一站式对接全链路医疗健康管理服务 </div>
      <div class="healthItem">
        <div class="itemLeft">
          <div class="top">
            <div class="topTitle">医院网络</div>
            <div class="severLine"></div>
            <div class="leftType">
              <span>就医服务</span>
              <span>理赔直付</span>
              <span>名院合作</span>
            </div>
            <div class="numberCon">
              <div class="number-box">
                <div class="number-box_item">
                  <div class="number-box_item_top">10000+</div>
                  <div class="number-box_item_bottom">全国直付垫付网络</div>
                </div>
                <div class="number-box_item">
                  <div class="number-box_item_top">1021</div>
                  <div class="number-box_item_bottom">全国就医三甲医院网络</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            分布在31个省，300+城市，2000+县
          </div>
        </div>
        <div class="itemRight">
          <img src="../../assets/image/med1.png" alt="" width="600" height="330">
        </div>
      </div>
       <div class="healthItem">
         <div class="itemRight">
          <img src="../../assets/image/med2.png" alt="" width="600" height="330">
        </div>
        <div class="itemLeft specialStyle">
          <div class="top">
            <div class="topTitle">商保医护网络</div>
            <div class="severLine"></div>
            <div class="leftType">
              <span>名医咨询</span>
              <span>线上门诊</span>
              <span>就医服务</span>
              <span>专家讲座</span>
            </div>
            <div class="numberCon">
              <div class="number-box">
                <div class="number-box_item">
                  <div class="number-box_item_top">20000+</div>
                  <div class="number-box_item_bottom">商保医生</div>
                  <div class="number-box_item_list ml3">
                    <p class="text"><span class="fb mr5">·</span>商保认证</p>
                    <p class="text"><span class="fb mr5">·</span>权威专业</p>
                    <p class="text"><span class="fb mr5">·</span>资源充足</p>
                    <p class="text"><span class="fb mr5">·</span>科室覆盖广</p>
                  </div>
                </div>
                <div class="number-box_item">
                  <div class="number-box_item_top">30000+</div>
                  <div class="number-box_item_bottom">商保护士</div>
                    <div class="number-box_item_list ml10">
                      <p class="text"><span class="fb mr5">·</span>严格质控标准</p>
                      <p class="text"><span class="fb mr5">·</span>商保权威认证</p>
                      <p class="text"><span class="fb mr5">·</span>专业护理背景</p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="healthItem">
        <div class="itemLeft">
          <div class="top">
            <div class="topTitle">健康服务机构</div>
            <div class="severLine"></div>
            <div class="leftType">
              <span>健康体检</span>
              <span>口腔眼科</span>
              <span>中医理疗</span>
            </div>
            <div class="numberCon">
              <div class="number-box">
               <div class="numberT">
                 <p class="text"><span class="fb">·</span> 全国范围体检、口腔、眼科、疫苗、中医合作网络超千家，大型连锁已实现系统对接</p>
                 <p class="text"><span class="fb">·</span> 美国、欧洲、日本等国家和地区优选医疗机构</p>
               </div>
              </div>
            </div>
          </div>
        </div>
        <div class="itemRight">
          <img src="../../assets/image/med3.png" alt="" width="600" height="330">
        </div>
      </div>
       <div class="healthItem">
        <div class="itemRight">
          <img src="../../assets/image/med4.png" alt="" width="600" height="330">
        </div>
        <div class="itemLeft">
          <div class="top">
            <div class="topTitle">医药</div>
            <div class="severLine"></div>
            <div class="leftType">
              <span>药品线上处方</span>
              <span>药品商城</span>
              <span>全国药品配送</span>
            </div>
            <div class="numberCon">
              <div class="number-box">
               <div class="numberT">
                 <p class="text"><span class="fb">·</span> 全国覆盖、极速配送</p>
                 <p class="text"><span class="fb">·</span> 线上问诊+药品处方</p>
                 <p class="text"><span class="fb">·</span> 药品商城在线一键购药</p>
               </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>
    </div>

    <div class="madeM">
      <img src="../../assets/image/medType.png" width="100%" alt="">
    </div>

    <div class="serveInterner">
      <div class="container">
        <div class="title">已建成特色自营医疗健康服务网络</div>
        <div class="serveContent">
          <div class="contentItem" v-for="(item,index) in serveInternerList" :key="index">
            <div class="location">
              <div class="bigT">{{item.circleTxt}}</div>
              <img v-if="index % 2 === 0" src="../../assets/image/black.png" alt="">
              <img v-else src="../../assets/image/orange.png" alt="">
            </div>
            <p>{{item.desc1}}</p>
            <p>{{item.desc2}}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="backgroundGray">
       <div class="container">
         <div class="partner">
           <div class="title">合作伙伴</div>
           <img src="../../assets/image/partnerPc.png" />
         </div>
        
      </div>
    </div>
   

  </div>
</template>

<script>
export default {
  data(){
    return {
      serveInternerList: [
        {
          circleTxt: '全',
          desc1:'涵盖医护健药的服务资源',
          desc2: '满足客户线上线下的需求'
        },
        {
          circleTxt: '广',
          desc1:'服务网络覆盖全国',
          desc2: '打造“百城万人”服务网络'
        },
        {
          circleTxt: '深',
          desc1:'国内TOP100医院专家合作',
          desc2: '顶级专科健管中心合作'
        },
        {
          circleTxt: '控',
          desc1:'商保医生控费体系',
          desc2: '商保护士服务体系'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.backgroundGray {
    background: #F7FAFF;
}
.medicalBox{
  display: flex;
  flex-direction: column;
}

.healthServe{
  padding: 140px 0;
  .healthItem{
    width: 100%;
    height: 330px;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    &:first-child{
      .itemLeft{
        .top {
          border-bottom: none;
        }
      }
    }
    .itemLeft{
      width: 600px;
      height: 328px;
      background: #FFFFFF;
      border: 1px solid #eaeef0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .top{
        width: 100%;
        height: 270px;
        padding-top: 63px;
        text-align: center;
        .topTitle{
          font-size: 24px;
          font-weight: 500;
          color: #333333;
        }
        .severLine{
          width: 20px;
          height: 3px;
          background: #fd8246;
          margin: 10px auto 20px;
        }
        .leftType {
          span {
            display: inline-block;
            font-size: 12px;
            color: #333333;
            text-align: center;
            padding: 6px;
            &:first-child {
              background: #DAD7FE;
            }
            &:nth-child(2) {
              background: #FFE5D3;
              margin: 0 20px;
            }
            &:nth-child(3){
              background: #E2FBD7;
            }
            &:nth-child(4) {
              background: #FFECE0;
              margin-left: 20px;
            }
          }
        }
        .numberCon{
          width: 100%;
          overflow: hidden;
          margin-top: 20px;
          .number-box{
            display: flex;
            justify-content: center;
            align-items: flex-start;
            .number-box_item{
              margin: 0 35px;
              .number-box_item_top{
                color: #333333;
                font-weight: 700;
                font-size: 26px;
                line-height: 30px;
              }
              .number-box_item_bottom{
                color: #333333;
                font-weight: 300;
                font-size: 16px;
                line-height: 40px;
              }
              .number-box_item_list{
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                p{
                  font-size:14px;
                  color: #666666;
                  line-height: 25px;
                  span{
                    margin-right: 5px;
                  }
                  
                }
              }
            }
            .numberT{
              // width: 496px;
              margin: 0 auto;
              color: #666666;
              text-align:left;
              p{
                width: 100%;
                color: #666666;
                line-height: 30px;
                margin-bottom: 10px;
              }
            }
            .width220{
              widtH: 220px;
            }
          }
        }
      }
      .bottom{
        height: 60px;
        color: #666;
        width: 100%;
        text-align:center;
        line-height: 60px;
         border-top: 1px solid rgba(234,238,240,.5);
      }
    }
    .specialStyle{
      .top{
        padding-top: 20px;
        border-bottom: none;
      }
      
    }
  }
}
.title{
  text-align: center;
  font-size:40px;
  color:#333333;
  margin-bottom: 48px;
  font-weight: 300;
}
.serveInterner{
    // height: 589px;
    width: 100%;
    background: #ffffff;
    padding: 140px 0 140px 0;
    .serveContent{
      width: 100%;
      // height:380px;
      overflow: hidden;
      // padding: 0 43px;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      .contentItem{
        width: 25%;
        font-size: 16px;
        // margin-right: 158px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        .location{
          position: relative; 
          width: 122px;
          height: 122px;
          margin-bottom: 15px;
          .bigT{
            font-size:30px;
            font-weight: 600;
            color: #FFFFFF;
            position: absolute;
            top: 31px;
            left: 45px;
            z-index: 99;
            line-height: 55px;
          }
          img{
            animation: run1 12s linear infinite;
            width: 122px;
            height: 122px;
          }
        }
        p{
          font-weight: 300;
          text-align: center;
          color: #333333;
          margin-bottom: 8px;
        }
        
       
      }
    }
}

.partner{
  width: 100%;
  padding: 140px 0;
  img{
    width: 100%;
  }
}
.ml3{
  margin-left: 3px;
}
.ml10{
  margin-left: 10px;
}
@keyframes run1 {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/pc/medicalPc.vue